
import React from 'react';
import { Button } from 'antd';

// 优化正则表达式，支持更多的URL格式并添加不区分大小写标志
export const isImg = /^https?:\/\/[\w\-]+(\.[\w\-]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?$/i;

// 处理本地图片路径的辅助函数
const processLocalImage = (imagePath) => {
  try {
    // 提取文件名，移除路径前缀
    const fileName = imagePath.split('/').pop();
    
    // 在开发环境中，使用正确的静态资源路径
    // React开发服务器会自动处理public目录下的静态资源
    // 但src/static目录需要特殊处理，使用相对路径
    return `../../static/hover/${fileName}`;
  } catch (error) {
    // 如果处理失败，返回一个默认的公共路径
    console.warn(`Failed to process image path: ${imagePath}`, error);
    const fileName = imagePath.split('/').pop();
    return `../../static/hover/${fileName}`;
  }
};

// 处理证书图片的专用函数
export const getCertificateImage = (imagePath) => {
  if (typeof imagePath !== 'string') return null;
  
  // 如果是完整的HTTP/HTTPS链接，直接返回
  if (imagePath.match(isImg)) {
    return imagePath;
  }
  
  // 处理本地图片路径
  return processLocalImage(imagePath);
};

export const getChildrenToRender = (item, i) => {
  let tag = item.name.indexOf('title') === 0 ? 'h1' : 'div';
  tag = item.href ? 'a' : tag;
  
  let children = null;
  
  if (typeof item.children === 'string') {
    if (item.children.match(isImg)) {
      // 处理远程图片
      children = React.createElement('img', { 
        src: item.children, 
        alt: 'img',
        onError: (e) => {
          // 远程图片加载失败时的回退处理
          e.target.onerror = null; // 防止无限循环
          console.warn(`Remote image failed to load: ${item.children}`);
          // 尝试使用本地同名图片
          const fileName = item.children.split('/').pop();
          e.target.src = `/static/hover/${fileName}`;
        }
      });
    } else if (item.name === 'image') {
      // 对于image类型的项，尝试处理本地图片路径
      try {
        const imageSrc = getCertificateImage(item.children);
        children = React.createElement('img', {
          src: imageSrc,
          alt: item.className === 'teams1-image' ? 'certificate' : 'img',
          onError: (e) => {
            // 图片加载失败时的回退处理
            e.target.onerror = null; // 防止无限循环
            console.error(`Image loading failed: ${imageSrc}`);
            
            // 尝试使用项目中存在的某个通用图片作为默认图
            const fallbackImages = ['高新技术企业证书.jpg', '首页logo.png', '动态表单系统.jpg'];
            let fallbackSrc = null;
            
            // 查找第一个存在的回退图片
            for (const fallbackImg of fallbackImages) {
              try {
                // 检查文件是否存在
                const fs = require('fs');
                const filePath = `../../static/hover/${fallbackImg}`;
                const fullPath = require.resolve(filePath, { paths: [__dirname] });
                
                if (fs.existsSync(fullPath)) {
                  fallbackSrc = require(filePath).default || require(filePath);
                  break;
                }
              } catch (err) {
                // 忽略错误，继续尝试下一个
              }
            }
            
            // 如果找到回退图片，则使用；否则显示文本提示
            if (fallbackSrc) {
              e.target.src = fallbackSrc;
            } else {
              e.target.alt = '图片加载失败';
              e.target.style.width = '100px';
              e.target.style.height = '100px';
              e.target.style.backgroundColor = '#f0f0f0';
              e.target.style.display = 'flex';
              e.target.style.alignItems = 'center';
              e.target.style.justifyContent = 'center';
              e.target.style.color = '#999';
              e.target.style.fontSize = '12px';
              e.target.style.textAlign = 'center';
              e.target.style.overflow = 'hidden';
            }
          }
        });
      } catch (error) {
        // 如果处理失败，显示错误信息
        console.error('Image processing error:', error);
        children = React.createElement('div', { 
          style: { 
            width: '100px', 
            height: '100px', 
            backgroundColor: '#f0f0f0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#999',
            fontSize: '12px',
            textAlign: 'center'
          } 
        }, '图片加载失败');
      }
    } else {
      // 默认使用原始文本
      children = item.children;
    }
  } else if (item.name.indexOf('button') === 0 && typeof item.children === 'object') {
    children = React.createElement(Button, {
      ...item.children
    });
  } else {
    // 默认使用原始子元素
    children = item.children;
  }
  
  // 确保每个元素都有唯一的key
  const uniqueKey = `${tag}-${i}-${Date.now()}`;
  return React.createElement(tag, { key: uniqueKey, ...item }, children);
};
